import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@mui/material';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
import ReactMarkdown from 'react-markdown';
import { Link, Button } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    height: 350,
    zIndex: 101,
    marginBottom: theme.spacing(20),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  subHeader: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  header: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  backgroundBox: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: theme.palette.alternative.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  container: {
    paddingTop: 150,
  },
  bodyText: {
    fontFamily: 'Flama-Book',
    fontSize: '18px',
    lineHeight: 1.7,
  },
  imageTag: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

const Sustainability = (props) => {
  const classes = useStyles();
  const { data } = props;

  const scrollRef = useRef();
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.search === '?id=2') {
      window.scrollTo(0, scrollRef.current.offsetTop - 60);
    }
  }, []);

  return (
    <Grid ref={scrollRef} container className={classes.container} alignItems="flex-start" spacing={4}>
      <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
        <Box position="relative" zIndex="100">
          <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
            <Typography variant="h5" className={classes.subHeader}>{data.technologicalInnovationTitle1}</Typography>
            <Typography variant="h3" className={classes.header}>{data.sustainabilityTitle}</Typography>
            <ReactMarkdown variant="h6" className={classes.bodyText}>{data.sustainabilityDescription}</ReactMarkdown>
          </AnimatedOnScroll>
        </Box>
        <Box mt={2} />
        <Link target="_blank" href="/static/docs/sustainability_report_WGH_2022.pdf">
          <Button variant="contained" size="large" color="primary" className={classes.button}>
            Sustainability Report 2022
            <GetApp fontSize="small" style={{ marginLeft: 5 }} />
          </Button>
        </Link>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
        <Box position="relative">
          <AnimatedOnScroll className={classes.image} animationIn="fadeIn" animationInDuration={1000}>
            <Box className={classes.image}>
              <img src={data ? data.sustainabilityPicture.url : '/'} className={classes.imageTag} alt="Sustainability Logo" />
            </Box>
          </AnimatedOnScroll>
          <AnimatedOnScroll animationIn="fadeIn" animationInDuration={500} screenOffset={-350}>
            <Box
              className={classes.backgroundBox}
              top={30}
              left={-270}
              width={628}
              height={423}
            />
          </AnimatedOnScroll>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Sustainability;
